import React, { Component } from "react";
import { Button } from "react-bootstrap";
class ButtonCommon extends Component {
  render() {
    const { style, type, className, onClick, handleClick, disabled, label, children } = this.props;
    return (
      <Button
        style={style}
        type={type}
        className={className}
        onClick={handleClick || onClick}
        disabled={disabled}
      >
        {label || children}
      </Button>
    );
  }
}

export default ButtonCommon;
